import { QueryClient } from '@tanstack/vue-query';

/**
 * The one query cache, shared by the components and the router.
 *
 * The router needs it so that `/` can decide BEFORE rendering whether this
 * person is a member: rendering the paywall first and redirecting once /v1/me
 * answered flashed the 9 € card at every member on every load.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      // One attempt; the retry is the Try again button. A scheduled retry can
      // be paused by TanStack's online manager and then never leaves `pending`
      // — lasti.fi found screens stuck on "Loading…" for ever.
      retry: false,
      networkMode: 'always',
    },
  },
});
